import React, { useEffect, useState } from "react";
import FileDownload from "js-file-download";
import axios from "axios";
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//Fetch Cyber Security Risk Managment List
export const fetchCyberSecurityRiskManagementList = async (
  companyProfileID: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/CyberSecurity/${companyProfileID}/Details`
    );

    // console.log("fetchCyberSecurityRiskManagementList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Supply Chain Risk Managment List
export const fetchSupplyChainRiskManagementList = async (
  companyProfileID: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/SupplyChain/${companyProfileID}/Details`
    );
    // console.log("fetchSupplyChainRiskManagementList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Risk Managment List
export const fetchRiskManagementList = async (
  type: string,
  companyProfileID: number
) => {
  const res =
    type === "supplyChain"
      ? await fetchSupplyChainRiskManagementList(companyProfileID)
      : await fetchCyberSecurityRiskManagementList(companyProfileID);
  return res;
};

//Fetch Cyber Security RM Plan Details
export const fetchCyberSecurityPlanDetails = async (
  csRiskManagementPlanID: number | undefined
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/CyberSecurity/Id/${csRiskManagementPlanID}/Details`
    );
    // console.log("fetchCyberSecurityPlanDetails res", res);
    return res.data.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Fetch Supply Chain RM Plan Details
export const fetchSupplyChainPlanDetails = async (
  supplyChainPlanID: number | undefined
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/SupplyChain/Id/${supplyChainPlanID}/Details`
    );
    // console.log("fetchSupplyChainPlanDetails res", res);
    return res.data.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Fetch Risk Managment Plan Details
export const fetchRiskManagementPlanDetails = async (
  type: string,
  id: number | undefined
) => {
  const res =
    type === "supplyChain"
      ? await fetchSupplyChainPlanDetails(id)
      : await fetchCyberSecurityPlanDetails(id);
  return res;
};

//Create Cyber Security RM Plan
export const createCyberSecurityRiskManagementPlan = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/Plan/RiskManagment/CyberSecurity/Create`,
      payload
    );
    // console.log("createCyberSecurityRiskManagementPlan res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Create Supply Chain RM Plan
export const createSupplyChainRiskManagementPlan = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/Plan/RiskManagment/SupplyChain/Create`,
      payload
    );
    // console.log("createSupplyChainRiskManagementPlan res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Create Risk Managment Plan
export const createRiskManagementPlan = async (type: string, payload: any) => {
  const res =
    type === "supplyChain"
      ? await createSupplyChainRiskManagementPlan(payload)
      : await createCyberSecurityRiskManagementPlan(payload);
  return res;
};

//Update Cyber Security RM Plan
export const updateCyberSecurityRiskManagementPlan = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/RiskManagment/CyberSecurity/Update`,
      payload
    );
    // console.log("updateCyberSecurityRiskManagementPlan res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Update Supply Chain RM Plan
export const updateSupplyChainRiskManagementPlan = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/RiskManagment/SupplyChain/Update`,
      payload
    );
    // console.log("updateSupplyChainRiskManagementPlan res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Update Risk Managment Plan
export const updateRiskManagementPlan = async (type: string, payload: any) => {
  const res =
    type === "supplyChain"
      ? await updateSupplyChainRiskManagementPlan(payload)
      : await updateCyberSecurityRiskManagementPlan(payload);
  return res;
};

//Create Cyber Security Risk Managment Revision History
export const createCyberSecurityRevisionHistory = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/Plan/RiskManagment/CyberSecurity/Revision/Create`,
      payload
    );
    // console.log("createCyberSecurityRevisionHistory res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Create Supply Chain Risk Managment Revision History
export const createSupplyChainRevisionHistory = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/Plan/RiskManagment/SupplyChain/Revision/Create`,
      payload
    );
    // console.log("createSupplyChainRevisionHistory res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Create Risk Managment Revision History
export const createRevisionHistory = async (
  isCyberSecurity: boolean,
  payload: any
) => {
  const res = isCyberSecurity
    ? await createCyberSecurityRevisionHistory(payload)
    : await createSupplyChainRevisionHistory(payload);
  return res;
};

//Delete Cyber Security RM Plan
export const deleteCyberSecurityRiskManagementPlan = async (
  id: number | undefined,
  userId: number
) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/RiskManagment/CyberSecurity/Delete/${id}/${userId}`
    );
    // console.log("deleteCyberSecurityRiskManagementPlan res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Delete Supply Chain RM Plan
export const deleteSupplyChainRiskManagementPlan = async (
  id: number | undefined,
  userId: number
) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/RiskManagment/SupplyChain/Delete/${id}/${userId}`
    );
    // console.log("deleteSupplyChainRiskManagementPlan res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Delete Risk Managment Plan
export const deleteRiskManagementPlan = async (
  type: string,
  id: number | undefined,
  userId: number
) => {
  const res =
    type === "supplyChain"
      ? await deleteSupplyChainRiskManagementPlan(id, userId)
      : await deleteCyberSecurityRiskManagementPlan(id, userId);
  return res;
};

//Download Cyber Security Risk Managment Plan
export const downloadCyberSecurityRiskManagementPlan = async (
  payload: any,
  companyProfileID: number
) => {
  try {
    axios({
      url: `${API_BASE_URL}/api/Plan/RiskManagment/CyberSecurity/GenerateDocument?CompanyProfileID=${companyProfileID}&csriskManagementPlanId=${payload.csRiskManagementPlanID}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      // console.log("downloadCyberSecurityRiskManagementPlan res", payload, response);
      FileDownload(
        response.data,
        `Cybersecurity Risk Management Plan version ${payload.version}.docx`
      );
    });
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Download Supply Chain Risk Managment Plan
export const downloadSupplyChainRiskManagementPlan = async (
  payload: any,
  companyProfileID: number
) => {
  try {
    axios({
      url: `${API_BASE_URL}/api/Plan/RiskManagment/SupplyChain/GenerateDocument?CompanyProfileID=${companyProfileID}&SupplyChainPlanID=${payload.supplyChainPlanID}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      // console.log("downloadSupplyChainRiskManagementPlan res", payload, response);
      FileDownload(
        response.data,
        `Supply Chain Risk Management Plan version ${payload.version}.docx`
      );
    });
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Download Risk Managment Plan
export const downloadRiskManagementPlan = async (
  isCyberSecurity: boolean,
  payload: any,
  companyProfileID: number
) => {
  const res = isCyberSecurity
    ? await downloadCyberSecurityRiskManagementPlan(payload, companyProfileID)
    : await downloadSupplyChainRiskManagementPlan(payload, companyProfileID);
  return res;
};

//Fetch Cyber Security Risk Managment Template
export const fetchCyberSecurityRiskManagementTemplate = async () => {
  try {
    // console.log("fetchCyberSecurityRiskManagementTemplate", folderDetails);
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/CyberSecurity/Template/Details`
    );
    // console.log("fetchCyberSecurityRiskManagementTemplate res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Supply Chain Risk Managment Template
export const fetchSupplyChainRiskManagementTemplate = async () => {
  try {
    // console.log("fetchSupplyChainRiskManagementTemplate", folderDetails);
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/SupplyChain/Template/Details`
    );
    // console.log("fetchSupplyChainRiskManagementTemplate res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const fetchRiskManagementTemplate = async (isCyberSecurity: boolean) => {
  const res = isCyberSecurity
    ? await fetchCyberSecurityRiskManagementTemplate()
    : await fetchSupplyChainRiskManagementTemplate();
  return res;
};

export const importRiskManagementPlan = async (payload: any) => {
  try {
    // console.log("importRiskManagementPlan", folderDetails);
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/RiskManagment/CyberSecurity/Template/Import`,
      payload
    );
    // console.log("importRiskManagementPlan res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const copyRiskManagementPlan = async (planId: any) => {
  try {
    // console.log("copyRiskManagementPlan", folderDetails);
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/CyberSecurity/Id/${planId}/Copy/Details`
    );
    // console.log("copyRiskManagementPlan res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const copySupplyChainRiskManagementPlan = async (planId: any) => {
  try {
    // console.log("copySupplyChainRiskManagementPlan", folderDetails);
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/SupplyChain/Id/${planId}/Copy/Details`
    );
    // console.log("copySupplyChainRiskManagementPlan res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};
